// extracted by mini-css-extract-plugin
export default {"list":"TraineeList_list__RqP4q"};